module.exports = __webpack_public_path__ + "static/media/saveforyourfuture.328f0290.svg";